import { Box, Button, colors, Container, Grid, Input, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Typography } from "@mui/material"
import Bottom from "../../Bottom";
import { useEffect, useState } from "react";
import api from "../../../utils/api_v2";
import LodingData from "../../../utils/LodingData";

import useStressStore from "../../../store/stressStores";
import { useLocation, useNavigate } from "react-router-dom";
import RaderChart from "./RaderChart";
import { ChartBullet, ChartContainer } from "@patternfly/react-charts";
import CropSquareIcon from '@mui/icons-material/CropSquare';
import tabbg from "../../../assets/images/tab_01.png"


const StressResult = () => {

  const storeData: any = useStressStore();
  const navigate = useNavigate();
  const location = useLocation();

  // 탭 관련 useState
  const [value, setValue] = useState(0);
  const handleTabChange = (_: any, newValue: any) => {
    setValue(newValue);
  };

  useEffect(() => {
    getResultList();
    getScoreList();

    return () => {
      storeData.resultClear();
    }
  }, [])

  function getResultList() {
    let userId: any = localStorage.getItem('userID');
    let familyId: any = localStorage.getItem('ownerFamID');

    api.get(`customer/api/v2/surveys/stress/families/${encodeURIComponent(familyId)}/survey_assigns/${location.state.assigned_uid}`, { headers: { 'userId': userId } })
      .then(res => {
        // console.log(res);

        const tempList = [];
        const { uid: assigned_uid, survey, year, info } = res.data.data;

        for (let i = 0; i < info.length; i++) {
          const { answer, question, result } = info[i];
          const category = result.category;
          const tempObj: any = {};

          tempObj.category = category.name;
          tempObj.category_uid = category.uid;
          tempObj.category_number = category.number;
          tempObj.description = category.description;

          tempObj.survey_uid = survey.uid;
          tempObj.survey_title = survey.title;
          tempObj.assigned_uid = assigned_uid;

          tempObj.year = year;
          tempObj.number = question.number;
          tempObj.title = question.title;

          tempObj.question_uid = question.uid;
          tempObj.type = question.type;

          tempObj.answer = answer;

          tempObj.strongly_disagree = question.option.strongly_disagree;
          tempObj.disagree = question.option.disagree;
          tempObj.agree = question.option.agree;
          tempObj.strongly_agree = question.option.strongly_agree;

          tempObj.result_uid = result.uid;
          tempObj.result_1_4 = result.score1per4;
          tempObj.result_2_4 = result.score2per4;
          tempObj.result_3_4 = result.score3per4;
          tempObj.result_4_4 = result.score4per4;

          tempList.push(tempObj);
        }

        storeData.setResultList(tempList);
      })
      .catch(err => {
        console.log(err);
      })
  }

  function getScoreList() {
    let userId: any = localStorage.getItem('userID');
    let familyId: any = localStorage.getItem('ownerFamID');

    LodingData(() => api.get(`customer/api/v2/surveys/stress/families/${encodeURIComponent(familyId)}/survey_assigns/${location.state.assigned_uid}/score`, { headers: { 'userId': userId } })
      .then(res => {
        // console.log(res);

        const { survey_assigned, family, info } = res.data.data;
        storeData.setSurveyAssigned(survey_assigned);
        storeData.setFamilyInfo(family);
        storeData.setSurveyInfoList(info);

      })
      .catch(err => {
        console.log(err);
      }));
  }

  // 탭 관련
  function TabPanel(props: any) {
    const { children, value, index, ...other } = props;

    // 탭이 변하면 다시 리랜더링 후 로우스팬 함수 실행
    useEffect(() => {
      if (value === index) {
        genRowspan('category');
      }
    }, [value]);

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <div>{children}</div>
          </Box>
        )}
      </div>
    );
  }
  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  // 카테고리 rowspan 함수
  const genRowspan = (className: string) => {
    const elements = Array.from(
      document.querySelectorAll(`.${className}`)
    ) as HTMLTableCellElement[];

    let lastCategory = "";
    let rowspan = 1;
    let firstElement: HTMLTableCellElement | null = null;

    elements.forEach((element) => {
      const text = element.textContent;

      if (text === lastCategory) {
        rowspan++;
        element.style.display = "none";
        if (firstElement) {
          firstElement.setAttribute("rowspan", rowspan.toString());
        }
      } else {
        lastCategory = text || "";
        rowspan = 1;
        firstElement = element;
        element.removeAttribute("rowspan");
        element.style.display = "";
      }
    });
  };

  // 데이터 라벨
  function getLabelData(d: any, score: any) {
    const { min, max, Q1, Q2, MID, Q3, Q4, IQR, SCORE } = getNumericFigure(d);
    score = !!!score ? SCORE : score;
    if (min <= score && score < Q1) return `하위 25%`;
    else if (Q1 <= score && score < Q2) return `하위 50%`;
    else if (Q2 <= score && score < Q3) return `상위 50%`;
    else if (Q3 <= score && score <= Q4) return `상위 25%`;
    else return "";
  }
  function getLabel(value: any) {
    if (0 <= value && value < 25) return `하위 25%`;
    else if (25 <= value && value < 50) return `하위 50%`;
    else if (50 <= value && value < 75) return `상위 50%`;
    else if (75 <= value && value <= 100) return `상위 25%`;
    else return "";
  }

  function getNumericFigure(d: any) {
    let Q1 = 0;
    if (!!d?.score1_4) Q1 = d?.score1_4;
    const Q2 = d.score2_4;
    const Q3 = d.score3_4;
    const Q4 = d.score4_4;
    const AVG = roundDecimalPoint(d.average, 1);
    const AVG_M = roundDecimalPoint(d.averageM, 1);
    const AVG_F = roundDecimalPoint(d.averageF, 1);
    return {
      min: 0,
      AVG: AVG,
      AVG_M: AVG_M,
      AVG_F: AVG_F,
      Q1: Q1,
      Q2: Q2,
      MID: roundDecimalPoint(Q2, 1),
      Q3: Q3,
      Q4: Q4,
      max: 0,
      IQR: Q3 - Q1,
      PQ01: Q1 / 2,
      PQ12: (Q1 + Q2) / 2,
      PQ23: (Q2 + Q3) / 2,
      PQ34: (Q3 + Q4) / 2,
      SCORE: roundDecimalPoint(d.score, 1),
    }
  }

  function roundDecimalPoint(doubles: any, points: any) {
    let roundPoint = 10.0;
    for (let i = 1; i <= points; i++) {
      roundPoint *= roundPoint;
    }
    return Math.round(doubles * roundPoint) / roundPoint;
  }

  function getColorForRadar(d: any, score: any) {
    let colors = ['#919191', //전국
      '#ffca47', //회사
      '#6e9f8c', //남성
      '#d59193', //여성
      '#6a41d2']; //본인
    if (!!!d && !!!score) return colors;
    const { Q1, Q2, Q3, Q4, SCORE, AVG, AVG_F, AVG_M } = getNumericFigure(d);
    score = score ?? SCORE;
    let i;
    if (0 <= score && score < Q1 || score === 0) i = 0;
    else if (Q1 <= score && score < Q2 || Q1 === 0 && score <= Q2) i = 1;
    else if (Q2 <= score && score < Q3) i = 2;
    else i = 3;
    return d.category_description.includes('높을수록') ? colors[i] : colors.reverse()[i];
  }

  function getColor(d: any, score: any) {
    // const colors = ['#f6f6f6', '#c6c3ce', '#687184', '#212331'];
    // const colors = ['#ecfaff',
    //   '#9facb5',
    //   '#51566f',
    //   '#212331'];
    const colors = ['#ecfaff',
      '#adbfca',
      '#475068',
      '#212331'];
    if (!!!d && !!!score) return colors;
    const { Q1, Q2, Q3, Q4, SCORE } = getNumericFigure(d);
    score = score ?? SCORE;
    let i;
    if (0 <= score && score < Q1 || score === 0) i = 0;
    else if (Q1 <= score && score < Q2 || Q1 === 0 && score <= Q2) i = 1;
    else if (Q2 <= score && score < Q3) i = 2;
    else i = 3;
    return d.category_description.includes('높을수록') ? colors[i] : colors.reverse()[i];
  }

  return (
    <Container className="container">
      <Box sx={img} >
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#8acd83', fontWeight: 900 }}>
              예약서비스
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ead3d', fontWeight: 500, }} gutterBottom>
              직무스트레스
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box>
        <Tabs
          className="tab_color"
          value={value}
          id="tab1"
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="wrapped label tabs example"
          sx={{'& button' :{color:'#0d6703!important'}, '& .MuiTabs-indicator' :{bgcolor:'#0d6703!important'}}}
        >
          <Tab label="결과요약" {...a11yProps(0)} />
          <Tab label="응답보기" {...a11yProps(1)} />
        </Tabs>

        <TabPanel value={value} index={0}>
          <Grid container className="White_box alignitem_center  justifycontent_spacebetween" sx={{mt: 2}}>
            <Grid item xs={4.5} className="display_flex">
              <RaderChart />
            </Grid>
            <Grid item xs={7} className="display_flex flexdirection_column alignitem_end " >
              <TableContainer>
                <Table size="small" className="Cl_table" >
                  <TableHead>
                    <TableRow sx={{ height: 'calc(100%/10)', minHeight: '40px' }} >
                      <TableCell sx={{ width: '15%', padding: '1rem' }}>항목</TableCell>
                      <TableCell sx={{ whiteSpace: 'nowrap', wordBreak: 'keep-all', padding: '1rem', width: '25%' }}>
                        <Typography  color='#0d6703' sx={{fontWeight:'bold'}}>{storeData.familyInfo.name} <span style={{color: "#333", fontWeight: 500}}>님의 점수</span></Typography> 
                      </TableCell>
                      <TableCell sx={{ width: '60%', padding: '1rem' }}>설명</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      storeData.surveyInfoList && storeData.surveyInfoList.map((item: any, idx: any) => {
                        let { category_description: desc, category_name: name, category_note: note } = item;
                        note = !note ? '' : note;

                        const { Q1, Q2, Q3, Q4, SCORE, AVG } = getNumericFigure(item);
                        const me = Math.abs(Number((getLabel(SCORE).replaceAll(/[\d]/ig, "").includes("상위") ? -125 : 0)) + Number(getLabel(SCORE).replaceAll(/[^\d]/ig, "")));
                        // const company = Math.abs(Number(getLabelData(item, AVG).replaceAll(/[\d]/ig, "").includes("상위") ? -125 : 0) + Number(getLabelData(item, AVG).replaceAll(/[^\d]/ig, "")));

                        return (
                          <TableRow sx={{ height: 'calc(100%/10)', fontSize: '90%' }} key={idx}>
                            <TableCell>{name}</TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap', wordBreak: 'keep-all' }}>
                              <Box sx={{ display: 'inline-block', position: 'relative', width: '30%', height: '30px', lineHeight: '30px', margin: '0 2.5% 0 0' }}>
                                <Typography component='div' sx={{ position: 'absolute', top: '7px', width: '100%', height: '100%', fontWeight: '500', fontSize: '90%', textAlign: 'right' }}>{SCORE} 점</Typography>
                              </Box>
                              <Box sx={{ display: 'inline-block', position: 'relative', width: '60%', height: '30px', lineHeight: '30px', margin: '0 0 0 2.5%' }}>
                                <Typography component='div' sx={{ position: 'absolute', width: `${me}%`, height: '100%', backgroundColor: `${getColor(item, SCORE)}cc` }}></Typography>
                                <Typography component='div' sx={{ position: 'absolute', width: '100%', height: '100%', fontWeight: '600', fontSize: '80%', color: `${me <= 50 ? 'black' : 'white'}`, lineHeight: '30px', textShadow: `-1px 0 ${me <= 50 ? 'white' : 'black'}, 0 1px ${me <= 50 ? 'white' : 'black'}, 1px 0 ${me <= 50 ? 'white' : 'black'}, 0 -1px ${me <= 50 ? 'white' : 'black'}` }}>{getLabel(SCORE)}</Typography>
                              </Box>
                            </TableCell>
                            <TableCell sx={{ width: '70%', padding: '8px 15px !important',}}>
                              <Box sx={{ flexWrap: 'wrap', flexDirection: 'row', textAlign: "left" }}>
                                <Box sx={{ fontSize: '16px', fontWeight: '500', m: '5px 0px' }}>
                                  {desc}
                                </Box>
                                {
                                  !note || note.length < 1
                                    ? ''
                                    : <Typography component='p' sx={{ fontSize: '12px', fontWeight: '500', color: '#565d72',  wordBreak:'keep-all' }}>{note}</Typography>
                                }
                              </Box>
                            </TableCell>
                          </TableRow>
                        )
                      })
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>

          <Grid container className="White_box alignitem_center" sx={{ height: '700px', width: '100%' }}>
            <Box className='display_flex'>
              {
                storeData.surveyInfoList && storeData.surveyInfoList.map((item: any, idx: any) => {
                  const { Q1, Q2, Q3, Q4, SCORE, AVG } = getNumericFigure(item);
                  // console.log(getNumericFigure(item));
                  // let left = item.category_number == null ? 50 : (230 * item.category_number) + 50;

                  return (
                    <ChartContainer
                      style={{
                        height: '700px',
                      }}
                      className="chartcontainer"
                    >
                      <ChartBullet
                        comparativeWarningMeasureData={[{ name: '회사 평균', y: AVG == -1 ? 0 : AVG }]}
                        // comparativeWarningMeasureLegendData={[{ name: 'Warning' }]}
                        constrainToVisibleArea
                        height={700}
                        horizontal={false}
                        labels={({ datum }) => {
                          if (0 < Q1) {
                            if (datum.name == '하위 25%') return `${datum.name}: 0 ~ ${Q1} 점`
                            else if (datum.name == '하위 50%') return `${datum.name}: ${Q1} ~ ${Q2} 점`
                            else if (datum.name == '상위 50%') return `${datum.name}: ${Q2} ~ ${Q3} 점`
                            else if (datum.name == '상위 25%') return `${datum.name}: ${Q3} ~ ${Q4} 점`
                          } else {
                            if (datum.name == '하위 25%') return `${datum.name}: 0 ~ 0 점`
                            else if (datum.name == '하위 50%') return `${datum.name}: 0 ~ ${Q2} 점`
                            else if (datum.name == '상위 50%') return `${datum.name}: ${Q2} ~ ${Q3} 점`
                            else if (datum.name == '상위 25%') return `${datum.name}: ${Q3} ~ ${Q4} 점`
                          }

                          return (
                            `${datum.name}: ${datum.y} 점`
                          )
                        }}
                        maxDomain={{ y: 100 }}
                        // name="chart18"
                        padding={{
                          bottom: 125, // Adjusted to accommodate legend
                          left: 50,
                          right: 50,
                          top: 50
                        }}
                        primarySegmentedMeasureData={[{ name: `-${getLabel(SCORE)}`, y: SCORE }]}
                        // primarySegmentedMeasureLegendData={[{ name: 'Measure 1' }, { name: 'Measure 2' }]}
                        qualitativeRangeData={[{ name: '하위 25%', y: Q1 }, { name: '하위 50%', y: Q2 }, { name: '상위 50%', y: Q3 }, { name: '상위 25%', y: Q4 }]}
                        // qualitativeRangeLegendData={[{ name: 'Range 1' }, { name: 'Range 2' }]}
                        standalone={false}
                        // subTitle="Measure details"
                        title={item.category_name}
                        width={500}
                      />
                    </ChartContainer>
                  )
                })
              }
            </Box>
          </Grid>
        </TabPanel>

        <TabPanel value={value} index={1}>
          <TableContainer>
            <Table size="small" className="Cl_table" sx={{mt: 2, '& td': {cursor: 'default', border:"1px solid #eee"}}}>
              <TableHead>
                <TableRow>
                  <TableCell>구분</TableCell>
                  <TableCell sx={{width: 50}}>#</TableCell>
                  <TableCell>내용</TableCell>
                  <TableCell>전혀<br/>그렇지 않다</TableCell>
                  <TableCell>그렇지 않다</TableCell>
                  <TableCell>그렇다</TableCell>
                  <TableCell>매우 그렇다</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  storeData.resultList && storeData.resultList.map((item: any, idx: number) => {
                    return (
                      <TableRow key={idx} id={`stress-${item.number}`}>
                        <TableCell className="category">{item.category}</TableCell>
                        <TableCell>{item.number}</TableCell>
                        <TableCell>{item.title}</TableCell>
                        <TableCell>
                          {/* <Input name={item.question_uid} type={item.type} value={item.strongly_disagree} disabled /> */}
                          <input name={item.question_uid} type={item.type} value={item.strongly_disagree} checked={item.strongly_disagree === item.answer ? true : false} disabled />
                        </TableCell>
                        <TableCell>
                          {/* <Input name={item.question_uid} type={item.type} value={item.disagree === item.answer ? true : false} disabled /> */}
                          <input name={item.question_uid} type={item.type} value={item.disagree} checked={item.disagree === item.answer ? true : false} disabled />
                        </TableCell>
                        <TableCell>
                          {/* <Input name={item.question_uid} type={item.type} value={item.agree === item.answer ? true : false} disabled /> */}
                          <input name={item.question_uid} type={item.type} value={item.agree} checked={item.agree === item.answer ? true : false} disabled />
                        </TableCell>
                        <TableCell>
                          {/* <Input name={item.question_uid} type={item.type} value={item.strongly_agree === item.answer ? true : false} disabled /> */}
                          <input name={item.question_uid} type={item.type} value={item.strongly_agree} checked={item.strongly_agree === item.answer ? true : false} disabled />
                        </TableCell>
                      </TableRow>
                    )
                  })
                }
              </TableBody>
            </Table>
          </TableContainer>
        </TabPanel>

      </Box>

      <Box sx={{ textAlign: 'center' }}><Button variant="contained" onClick={() => navigate(-1)} sx={{mt: 5, mb: 5, background: '#0d6703', width: '30%', borderRadius: 20, '&:hover': { background: '#074300' } }}>목록</Button></Box>

      <Bottom />
    </Container>
  )
}


const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}

export default StressResult;